// src/components/profiles/filters/FilterUtils.js
export const extractFilterOptions = (profiles) => {
  if (!profiles || !profiles.length) {
    return {
      cities: [],
      professions: [],
      religions: [],
      education: [],
      castes: [],
      hobbies: [],
      languages: []
    };
  }

  const uniqueCities = [...new Set(profiles.map(p => p.city).filter(Boolean))].sort();
  const uniqueProfessions = [...new Set(profiles.map(p => p.job_title).filter(Boolean))].sort();
  const uniqueReligions = [...new Set(profiles.map(p => p.religion).filter(Boolean))].sort();
  const uniqueEducation = [...new Set(profiles.map(p => p.highest_degree).filter(Boolean))].sort();
  const uniqueCastes = [...new Set(profiles.map(p => p.caste).filter(Boolean))].sort();
  
  // Extract all hobbies
  const allHobbies = profiles.flatMap(p => p.hobbies || []).filter(Boolean);
  const uniqueHobbies = [...new Set(allHobbies)].sort();
  
  // Extract all languages
  const allLanguages = profiles.flatMap(p => p.languages_known || []).filter(Boolean);
  const uniqueLanguages = [...new Set(allLanguages)].sort();

  return {
    cities: uniqueCities,
    professions: uniqueProfessions,
    religions: uniqueReligions,
    education: uniqueEducation,
    castes: uniqueCastes,
    hobbies: uniqueHobbies,
    languages: uniqueLanguages
  };
};

export const calculateAgeStats = (profiles) => {
  if (!profiles || !profiles.length) {
    return {
      minAge: 20,
      maxAge: 40,
      averageAge: 30
    };
  }

  const ages = profiles.map(p => p.age).filter(age => age !== null && !isNaN(age));
  
  if (ages.length === 0) {
    return {
      minAge: 20,
      maxAge: 40,
      averageAge: 30
    };
  }

  const minAge = Math.min(...ages);
  const maxAge = Math.max(...ages);
  const averageAge = Math.round(ages.reduce((sum, age) => sum + age, 0) / ages.length);

  return {
    minAge: Math.max(18, minAge),
    maxAge: Math.min(80, maxAge),
    averageAge
  };
};